import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { serverMessage } from "../../utils/serverMessage";
import { url } from "../../utils/config";
import { getToken } from "../../utils/tokenStorage";
import { toast } from "react-toastify";
import { delayMessage } from "../../utils/delayMessage";

interface SaveLater {
  saveForLater: Object[];
  isSaveForLaterLoading: boolean;
  isSaveDeleteLoading: boolean;
  pendingRequestTimer: any;
}

const initialState: SaveLater = {
  saveForLater: [],
  isSaveForLaterLoading: false,
  isSaveDeleteLoading: false,
  pendingRequestTimer: null,
};

export const saveForLaterAction = createAsyncThunk(
  "saveLater",
  async (_, thunkAPI) => {
    try {
      const token = getToken();
      const { data } = await axios.get(`${url.baseUrl}/saveForLater`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      //   console.log(data);
      return data;
    } catch (error: any) {
      console.log(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteSaveAction = createAsyncThunk(
  "deleteSaves",
  async (index: string, thunkAPI) => {
    try {
      const token = getToken();

      const { data } = await axios.delete(
        `${url.baseUrl}/saveForLater/${index}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(data);
      return data;
    } catch (error: any) {
      console.log(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const saveForLaterSlice = createSlice({
  name: "saveForLater",
  initialState,
  reducers: {
    //
  },

  extraReducers: (builder) => {
    // Add save for later
    builder
      .addCase(saveForLaterAction.pending, (state) => {
        state.isSaveForLaterLoading = true;
        // Start a timer to show toast message if request is still pending after 10 seconds
        if (state.pendingRequestTimer) {
          clearTimeout(state.pendingRequestTimer);
        }
        state.pendingRequestTimer = setTimeout(delayMessage, 10000);
      })
      .addCase(saveForLaterAction.fulfilled, (state, { payload }) => {
        state.isSaveForLaterLoading = false;
        state.saveForLater = payload.data.saveForLater;
        // Clear timeout
        if (state.pendingRequestTimer) {
          clearTimeout(state.pendingRequestTimer);
          state.pendingRequestTimer = null; // Reset the timer ID
        }
      })
      .addCase(saveForLaterAction.rejected, (state, { payload }: any) => {
        state.isSaveForLaterLoading = false;
        serverMessage(payload);
        // Clear timeout
        if (state.pendingRequestTimer) {
          clearTimeout(state.pendingRequestTimer);
          state.pendingRequestTimer = null; // Reset the timer ID
        }
      });

    // Delete save for later
    builder
      .addCase(deleteSaveAction.pending, (state) => {
        state.isSaveDeleteLoading = true;
        // Start a timer to show toast message if request is still pending after 10 seconds
        state.pendingRequestTimer = setTimeout(delayMessage, 10000);
      })
      .addCase(deleteSaveAction.fulfilled, (state, { payload }: any) => {
        state.isSaveDeleteLoading = false;
        state.saveForLater = payload.data.saves;
        toast.success(`Job successfully removed from saves`);
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      })
      .addCase(deleteSaveAction.rejected, (state, { payload }: any) => {
        state.isSaveDeleteLoading = false;
        serverMessage(payload);
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      });
  },
});

export default saveForLaterSlice.reducer;
